import { gql } from '@apollo/client'

export const GET_ALL_JURISDICTIONS_AND_SUBS = gql`
  query GetAllJurisdictionsAndSubs($jurisdiction_id: Int) {
    getAllJurisdictionsAndSubs(jurisdiction_id: $jurisdiction_id) {
      id
      name
      SubsOfJurisdiction {
        id
        jurisdiction_id
        name
      }
    }
  }
`
